
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// MUI
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';

// DATA
import * as datasetActions from 'data/datasets/actions';
import { getDatasetsById, getLoadPending, isLoading, getError } from 'data/datasets/selectors';

// custom
import LoadingView from 'components/LoadingView';
import QButton from 'components/QButton';


export const useAlternateBackgroundColor = 'is-getting-started-acme-page';

const styles = (theme) => ({
  dialogStyle: {
    zIndex: '1200 !important',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.greyScale[7],
    width: '100%',
    maxHeight: '100%',
    height: 500,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 3,
  },
});

class ResolveDatasetDialog extends PureComponent { // eslint-disable-line react/prefer-stateless-function

  constructor(props) {
    super(props);

    if (!props.isDatasetsLoading) {
      props.dispatchGetDatasetsAction();
    }
  }

  render() {
    const { classes, datasets, isDatasetsLoadPending, isDatasetsLoading, datasetError, dispatchGetDatasetsAction } = this.props;

    return (
      <Dialog
        open={datasets.size === 0}
        fullWidth
        maxWidth="md"
        disableBackdropClick
        disableEscapeKeyDown
        disableEnforceFocus
        classes={{
          root: classes.dialogStyle,
        }}
      >
        <div className={classes.root}>
          {isDatasetsLoadPending && !isDatasetsLoading && datasets.size === 0 && datasetError ?
            <>

              <Typography variant="h4" style={{ paddingBottom: 24 }}>
                Oops!
              </Typography>
              <Typography variant="h6">
                {`We're having trouble retrieving your dataset.`}
              </Typography>
              <QButton variant="contained" style={{ marginTop: 36 }} onClick={dispatchGetDatasetsAction}>
                Try Again
              </QButton>
            </>
            :
            <LoadingView />
          }
        </div>
      </Dialog>
    );
  }
}

ResolveDatasetDialog.propTypes = {
  classes: PropTypes.object,
  dispatchGetDatasetsAction: PropTypes.func,
  datasets: PropTypes.object,
  datasetError: PropTypes.object,
  isDatasetsLoadPending: PropTypes.bool,
  isDatasetsLoading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    datasets: getDatasetsById(state),
    isDatasetsLoadPending: getLoadPending(state),
    isDatasetsLoading: isLoading(state),
    datasetError: getError(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetDatasetsAction: () => dispatch(datasetActions.getDatasets()),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(ResolveDatasetDialog);
